import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import AddStaffModal from "pagesV2/pro/Staff/AddStaffModal"
import { getCrewProfile, updateCrewProfile } from "store/crew-profiles"

const EditCrewMemberModal = ({ open, onCancel, onSave, crewMember, context = "crew" }) => {
  const { t } = useTranslation()

  const title = context === "staff" ? t("staff.edit.title") : t("crewMember.edit.title")

  return (
    <AddStaffModal
      open={open}
      onCancel={onCancel}
      onSave={onSave}
      staffId={crewMember?.id}
      editMode={true}
      getProfileAction={getCrewProfile}
      updateProfileAction={updateCrewProfile}
      customTitle={title}
      memberType={context}
    />
  )
}

EditCrewMemberModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  crewMember: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  context: PropTypes.oneOf(["crew", "staff"])
}

export default EditCrewMemberModal
